export type IfcArtifactsStatus = 'pending' | 'processing' | 'ready' | 'failed';

// `container` é o layout provado (geometry.parquet concatenado). `split` é a
// otimização de range request, ainda não validada — os dois coexistem por isso.
export interface IIfcGeometryContainer {
  layout: 'container';
  geometry: string;
}

export interface IIfcGeometrySplit {
  layout: 'split';
  mesh: string;
  vertex: string;
  index: string;
}

export type IIfcGeometryUrls = IIfcGeometryContainer | IIfcGeometrySplit;

export interface IIfcArtifactUrls {
  geometry: IIfcGeometryUrls;
  metadata: string;
  datamodel?: string;
  symbolic?: string;
}

export interface IIfcArtifacts {
  status: IfcArtifactsStatus;
  sha256: string;
  cacheFormatVersion: string;
  urls?: IIfcArtifactUrls;
  expiresAt?: string;
  progress?: number;
}

export type IIfcArtifactsReady = IIfcArtifacts & { urls: IIfcArtifactUrls };

// Só exige o Tier 1 (geometria + metadata): é o que desenha. datamodel/symbolic
// são Tier 2 e nunca foram exercitados do CDN — exigi-los bloquearia o render
// por um arquivo que ninguém lê ainda.
export const hasReadyIfcArtifacts = (
  artifacts?: IIfcArtifacts | null,
): artifacts is IIfcArtifactsReady => {
  if (!artifacts || artifacts.status !== 'ready' || !artifacts.urls?.metadata) { return false; }

  const geometry = artifacts.urls.geometry;
  if (!geometry) { return false; }

  return geometry.layout === 'container'
    ? Boolean(geometry.geometry)
    : Boolean(geometry.mesh && geometry.vertex && geometry.index);
};
